import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Leaf, Home, ArrowLeft } from 'lucide-react';
import { MetaTags } from '../components/seo/MetaTags';

export function NotFound() {
  return (
    <>
      <MetaTags
        title="404 - Page Not Found"
        description="The page you're looking for doesn't exist."
        noindex={true}
      />
      <div className="min-h-screen bg-gradient-to-b from-emerald-50/50 to-transparent pt-24 px-4 flex items-center">
        <div className="max-w-3xl mx-auto text-center">
          {/* Animated 404 Text */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="mb-8"
          >
            <div className="inline-flex items-center justify-center p-3 bg-emerald-100 rounded-full mb-6">
              <Leaf className="w-8 h-8 text-emerald-600" />
            </div>
            <h1 className="text-8xl font-bold text-gray-900 mb-4">404</h1>
            <p className="text-2xl text-gray-600 mb-2">Page Not Found</p>
            <p className="text-gray-500">
              Looks like this page has gone to seed! 🌱
            </p>
          </motion.div>

          {/* Animated Plant Illustration */}
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="mb-12"
          >
            <img
              src="https://images.unsplash.com/photo-1520412099551-62b6bafeb5bb?auto=format&fit=crop&w=600&h=400&q=80"
              alt="Lost plant"
              className="w-full max-w-md mx-auto rounded-lg shadow-xl"
            />
          </motion.div>

          {/* Action Buttons */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
            className="flex flex-col sm:flex-row items-center justify-center gap-4"
          >
            <Link
              to="/"
              className="inline-flex items-center gap-2 px-6 py-3 bg-emerald-600 text-white rounded-lg hover:bg-emerald-700 transition-colors"
            >
              <Home className="w-5 h-5" />
              Return Home
            </Link>
            <button
              onClick={() => window.history.back()}
              className="inline-flex items-center gap-2 px-6 py-3 border-2 border-emerald-600 text-emerald-600 rounded-lg hover:bg-emerald-50 transition-colors"
            >
              <ArrowLeft className="w-5 h-5" />
              Go Back
            </button>
          </motion.div>

          {/* Helpful Links */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.6 }}
            className="mt-12 text-sm text-gray-500"
          >
            <p>Looking for something specific? Try these:</p>
            <div className="flex items-center justify-center gap-4 mt-2">
              <Link
                to="/identifier"
                className="hover:text-emerald-600 transition-colors"
              >
                Plant Identifier
              </Link>
              <span>•</span>
              <Link
                to="/help"
                className="hover:text-emerald-600 transition-colors"
              >
                Help Center
              </Link>
              <span>•</span>
              <Link
                to="/dashboard"
                className="hover:text-emerald-600 transition-colors"
              >
                Dashboard
              </Link>
            </div>
          </motion.div>
        </div>
      </div>
    </>
  );
}
